module.exports = __webpack_public_path__ + "img/land_characteristics_valley.3b820462.png";